import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const PaginationStyles = styled.div`
  ul {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin: 2px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1;
    color: ${props => props.theme.palette.general.strong};
    text-decoration: none;
    width: 30px;
    height: 30px;
    background: ${props => props.theme.palette.general.light};
    border: 1px solid ${props => props.theme.palette.general.greyLight};
  }

  li.active {
    a {
      font: ${font('default', 'bold', '14px/1')};
    }
  }
`
